
import { useRef } from "react";
import { useIntersectionObserver } from "../../hooks/useIntersectionObserver";
import { Separator } from "../ui/separator";
import VideoPlayer from "../common/VideoPlayer";

const features = [{
  title: "Performance Tracking",
  description: "Track your media performance metrics in real-time to optimize your campaigns effectively."
}, {
  title: "ROI Analysis",
  description: "Measure and analyze return on investment across all your marketing channels."
}, {
  title: "Trend Insights",
  description: "Identify emerging patterns and trends to stay ahead of market changes."
}];

const DataDriven = () => {
  // Use standard animation behavior for the container (animate once)
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true,
    resetOnEachView: false
  });

  return <section className="pt-0 pb-6 md:py-6 px-0 md:px-6 bg-[#FAF9F8]">
      <div ref={ref} className={`max-w-7xl mx-auto bg-white p-6 md:p-12 rounded-xl transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-start">
          <div className="flex flex-col justify-between h-full space-y-4 md:space-y-6 order-1 md:order-1">
            <div className="space-y-4 md:space-y-6">
              <div className="flex flex-col items-start gap-1 md:gap-4">
                <div className="flex items-center gap-4">
                  <img src="/lovable-uploads/730cd03b-f6b3-400a-8ce8-0188e8750603.png" alt="Analytics Chart" className="w-12 h-12 md:w-16 md:h-16 object-contain" />
                  <p className="text-sm font-medium tracking-wider text-secondary uppercase">TRACK</p>
                </div>
                <h2 className="text-[2.25rem] leading-[1.1] md:text-6xl font-medium tracking-tight text-primary font-charter">
                  Make decisions with confidence
                </h2>
              </div>
              <p className="text-sm md:text-xl text-secondary">
                Our advanced analytics platform helps you understand your media performance
                and optimize your strategy in real-time.
              </p>
            </div>
            <div className="flex justify-start">
              <a 
                href="https://app.plannifi.com/auth/sign-up"
                className="px-6 py-2 md:py-3 text-sm md:text-base bg-white md:bg-black text-black md:text-white border md:border-0 border-black rounded-full hover:bg-[#27B5FC] hover:border-transparent hover:text-black transition-colors duration-300"
              >
                Start Tracking
              </a>
            </div>
          </div>
          <div className="order-2 md:order-2">
            <VideoPlayer 
              videoSrc="/lovable-uploads/still-box-for-graph.mp4"
              posterSrc="/lovable-uploads/still-box-for-graph-test(once-play).gif"
              altText="Data Driven visualization"
              className="z-10"
            />
          </div>
        </div>
        
        <Separator className="my-12 hidden md:block" />
        
        <div className="md:grid md:grid-cols-3 md:gap-8 mt-6 md:mt-12">
          {features.map((feature, index) => <div key={index} className="flex flex-col">
              <div className="py-2 md:py-0">
                <h3 className="text-base md:text-lg font-semibold text-primary mb-0.5">{feature.title}</h3>
                <p className="text-sm text-secondary">{feature.description}</p>
              </div>
              {index < features.length - 1 && <hr className="border-t border-gray-200 md:hidden my-1" />}
            </div>)}
        </div>
      </div>
    </section>;
};

export default DataDriven;
